import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/lib/auth";
import ProtectedRoute from "@/components/ProtectedRoute";
import AdminRoute from "@/components/AdminRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Pipeline from "@/pages/Pipeline";
import Leads from "@/pages/Leads";
import LeadDetail from "@/pages/LeadDetail";
import Analytics from "@/pages/Analytics";
import ImportExport from "@/pages/ImportExport";
import NegativeLeads from "@/pages/NegativeLeads";
import NegativeLeadDetail from "@/pages/NegativeLeadDetail";
import AdminUsers from "@/pages/AdminUsers";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <Routes>
                        <Route path="/login" element={<Login />} />
                        <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
                            <Route index element={<Dashboard />} />
                            <Route path="pipeline" element={<Pipeline />} />
                            <Route path="leads" element={<Leads />} />
                            <Route path="leads/:id" element={<LeadDetail />} />
                            <Route path="negative-leads" element={<NegativeLeads />} />
                            <Route path="negative-leads/:id" element={<NegativeLeadDetail />} />
                            <Route path="analytics" element={<Analytics />} />
                            <Route path="import" element={<ImportExport />} />
                            <Route path="admin/users" element={<AdminRoute><AdminUsers /></AdminRoute>} />
                        </Route>
                    </Routes>
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
